<template>
  <div class="xmxy_container" v-loading.fullscreen.lock="fullscreenLoading">
    <div>
      <div class="card_1">
        <div class="card_1_item" @click="handleToTjList()">
          <div>
            <span>一把手变更次数</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="发生一把手变更的项目次数"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt=""
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.ybsIndexData.ybsbdCount }}</div>
        </div>
        <div class="card_1_item" @click="handleToTjList()">
          <div>
            <span>完成正式拜访次数</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="发生一把手变更后执行正式拜访的项目次数"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt=""
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.ybsIndexData.zsbfCount }}</div>
        </div>
        <div class="card_1_item" @click="handleToTjList()">
          <div>
            <span>完成正式汇报次数</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="发生一把手变更后执行正式汇报的项目次数"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt=""
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.ybsIndexData.zshbCount }}</div>
        </div>
        <div class="card_1_item" @click="handleToTjList()">
          <div>
            <span>完成正式访谈次数</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="发生一把手变更后执行正式访谈的项目次数"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt=""
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.ybsIndexData.zsftCount }}</div>
        </div>
      </div>
      <div class="xmxy_middle">
        <div class="card_4">
          <div class="card_title">
            <span>快捷链接</span>
          </div>
          <div class="card_4_content">
            <div @click="ybsbgApplyDialog = true" v-if="user.bntqxzt == 2">
              一把手变更申请
            </div>
            <div @click="applyDialog = true" v-if="user.bntqxzt == 2">
              一把手变更发函申请
            </div>
            <div @click="handleToFhList(0)" v-if="user.bntqxzt == 2">
              一把手变更发函确认({{ zxlc.ybsIndexData.dclCount }})
            </div>
            <div @click="handleToFhList()" v-if="user.bntqxzt == 0">
              一把手变更发函
            </div>
            <div @click="handleToFhList(1)" v-if="user.bntqxzt == 1">
              一把手变更处理({{ zxlc.ybsIndexData.dclCount }})
            </div>
            <div @click="handleToMxList()">一把手变更明细</div>
            <div @click="handleToTjList()">一把手变更统计</div>
            <div @click="handleToHldList()">行领导变更明细</div>
          </div>
        </div>
        <div class="card_2">
          <div class="card_title">
            <span>一把手变更流程执行动态</span>
          </div>
          <div>
            <el-table
              :max-height="300"
              :data="zxlc.ybsIndexData.ybsbdZxList"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="项目名称"
                align="left"
                prop="xmmc"
                min-width="150px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="最佳模型节点"
                align="left"
                prop="name"
                min-width="105px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="执行人"
                align="left"
                prop="zxr"
                min-width="65px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="执行状态"
                align="left"
                prop="dict_label"
                min-width="100px"
                sortable
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="预计完成时间"
                align="left"
                prop="end_time"
                min-width="130px"
                sortable
                :show-overflow-tooltip="true"
              />
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </div>
        </div>
        <div class="card_3">
          <div class="card_title">
            <span>一把手变更流程执行占比</span>
          </div>
          <div class="card_3_content">
            <div
              id="card_3_chart_ybs"
              v-show="
                zxlc.ybsIndexData.ybsbdLczbList &&
                zxlc.ybsIndexData.ybsbdLczbList.length > 0
              "
            ></div>
            <el-empty
              description="暂无数据"
              v-show="
                !zxlc.ybsIndexData.ybsbdLczbList ||
                zxlc.ybsIndexData.ybsbdLczbList.length == 0
              "
            ></el-empty>
          </div>
        </div>
      </div>
      <div class="xmxy_bottom">
        <div class="card_5">
          <div class="card_title">
            <span>一把手变更项目</span>
          </div>
          <div class="card_5_content">
            <div class="card_5_content_left">
              <div class="card_5_suntitle">一把手变更次数</div>
              <div
                id="card_5_chart_ybs"
                v-show="
                  zxlc.ybsIndexData.ybsbdList &&
                  zxlc.ybsIndexData.ybsbdList.length > 0
                "
              ></div>
              <el-empty
                description="暂无数据"
                v-show="
                  !zxlc.ybsIndexData.ybsbdList ||
                  zxlc.ybsIndexData.ybsbdList.length == 0
                "
              ></el-empty>
            </div>
            <div class="card_5_content_right">
              <div class="card_5_suntitle">一把手变更流程执行率排行</div>
              <div>
                <div
                  v-for="(item, index) in zxlc.ybsIndexData.ybsbdZxlphList"
                  :key="index"
                >
                  <span>
                    <span class="rank_index">{{ index + 1 }}</span>
                    <span>{{ item.bmmc }}</span></span
                  >
                  <span>{{ item.zb }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="一把手变更发函申请"
      :visible.sync="applyDialog"
      width="90%"
      v-if="applyDialog"
      id="mx-dialog"
    >
      <YbsfhApply ref="apply" @giveFather="getSon"></YbsfhApply>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit(1)">提 交</el-button>
        <el-button @click="applyDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="一把手变更申请"
      :visible.sync="ybsbgApplyDialog"
      width="90%"
      v-if="ybsbgApplyDialog"
    >
      <YbsbgApply ref="ybsbgApply" @giveFather="getSon"></YbsbgApply>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmitYbsbg(1)"
          >提 交</el-button
        >
        <el-button @click="ybsbgApplyDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as echarts from "echarts";
import YbsfhApply from "@/views/zxlc/ybs/applyForm";
import YbsbgApply from "@/views/zxlc/ybs/ybsbgApplyForm";

export default {
  name: "xmxy_index",
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc"]),
  },
  props: ["activeName"],
  components: { YbsfhApply, YbsbgApply },
  data() {
    return {
      mxParams: {},
      applyDialog: false,
      ybsbgApplyDialog: false,
      roleName: "",
      fullscreenLoading: false,
    };
  },
  created() {
    // setTimeout(() => {
    //   const docH = document.documentElement.clientHeight;
    //   document.querySelector(".xmxy_container").style.minHeight =
    //     docH - 100 + "px";
    // }, 50);
    if (!this.zxlc.ybsIndexData?.ybsbdCount) {
      this.fullscreenLoading = true;
      this.$store
        .dispatch("zxlc/fetchYbsIndexDataAction", {
          year: new Date().getFullYear() + "",
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.code == 0) {
            this.randerBar2Ybs();
            this.randerBarYbs();
          } else {
            this.$message.error(res.msg);
          }
        });
    } else {
      this.$nextTick(() => {
        this.randerBar2Ybs();
        this.randerBarYbs();
      });
    }
  },
  mounted() {
    if (sessionStorage.getItem("acitveNameZxlc") == "second") {
      window.addEventListener("resize", () => {
        this.randerBar2Ybs(true);
        this.randerBarYbs(true);
      });
    }
  },
  methods: {
    handleClick() {},
    randerBarYbs(isResize) {
      var chartDom = document.getElementById("card_5_chart_ybs");
      var myChart = echarts.init(chartDom);
      var option;
      if (isResize) {
        myChart.resize();
        return;
      }
      let xList = [];
      let yList = [];
      this.zxlc.ybsIndexData.ybsbdList.forEach((item) => {
        xList.push(item.bmmc);
        yList.push(item.xms);
      });
      option = {
        grid: {
          left: "8%",
          right: "3%",
          top: "6%",
          bottom: "12%",
        },
        xAxis: {
          type: "category",
          data: xList,
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#333",
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        series: [
          {
            data: yList,
            type: "bar",
            barWidth: "30",
            itemStyle: {
              normal: {
                color: "#036eb8",

                label: {
                  show: true,
                  textStyle: {
                    //数值样式
                    color: "#666", //字体颜色
                  },
                  position: "top",
                },
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    randerBar2Ybs(isResize) {
      var chartDom = document.getElementById("card_3_chart_ybs");

      var myChart = echarts.init(chartDom);
      var option;
      if (isResize) {
        myChart.resize();
        return;
      }
      let labelList = [];
      let dataList = [];
      if (
        this.zxlc.ybsIndexData.ybsbdLczbList &&
        this.zxlc.ybsIndexData.ybsbdLczbList.length > 0
      ) {
        this.zxlc.ybsIndexData.ybsbdLczbList.forEach((item) => {
          labelList.push(item.name);
          dataList.push(item.zb);
        });
      }

      option = {
        tooltip: {
          trigger: "item",
          formatter: function (arr) {
            return `${arr.name}  ${arr.value}%`;
          },
        },
        grid: {
          left: "25%",
          // right: "50%",
        },
        // legend: {
        //   type: "plain",
        //   top: "5%",
        //   orient: "vertical",
        //   itemWidth: 16,
        //   formatter: (name) => {
        //     //  自定义图例
        //     let arr = [];
        //     let percent;
        //     for (const item of dataList) {
        //       if (item.name === name) {
        //         percent = item.value + "%";
        //       }
        //     }
        //     arr = ["{a|" + name + "}", "{b|" + percent + "}"];
        //     return `${name} | ${percent}`;
        //   },
        // },
        xAxis: {
          type: "value",
          data: dataList,
          axisTick: {
            alignWithLabel: true,
            show: true,
          },

          axisLine: {
            show: true,
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#333",
            show: true,
            formatter: function (value) {
              return ` ${value}%`;
            },
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "category",
          data: labelList,
          axisLabel: {
            color: "#333",
            rotate: -45,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: { color: "#ccc" },
          },
        },

        series: [
          {
            data: dataList,
            type: "bar",
            barWidth: "15",
            itemStyle: {
              normal: {
                color: (params) => {
                  const colorList = [
                    "#036eb8",
                    "#36CBCB",
                    "#4DCB73",
                    "#FAD53F",
                    "#F2637B",
                    "#975FE4",
                    "#036eb8",
                    "#36CBCB",
                    "#4DCB73",
                    "#FAD53F",
                    "#F2637B",
                    "#975FE4",
                    "#036eb8",
                    "#36CBCB",
                    "#4DCB73",
                    "#FAD53F",
                    "#F2637B",
                    "#975FE4",
                  ];
                  return colorList[params.dataIndex];
                },
                label: {
                  show: true,
                  textStyle: {
                    //数值样式
                    color: "#666", //字体颜色
                  },
                  position: "right",
                  formatter: function (arr) {
                    return ` ${arr.value}%`;
                  },
                },
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    handleDealFilter(arr, key, replaceKey) {
      let newArr = [];
      arr.forEach((item, index) => {
        for (var i = 0; i < key.length; i++) {
          item[key] = item[replaceKey];
        }
        newArr.push(item);
      });
      return newArr;
    },
    renderPieYbs(isResize) {
      var chartDom = document.getElementById("card_3_chart_ybs");
      var myChart = echarts.init(chartDom);

      var option;
      if (isResize) {
        myChart.resize();
        return;
      }
      const data = this.handleDealFilter(
        this.zxlc.ybsIndexData.ybsbdLczbList,
        "value",
        "zb"
      );

      option = {
        tooltip: {
          trigger: "item",
          formatter: function (arr) {
            return `${arr.name}  ${arr.value}%`;
          },
        },
        grid: {
          left: "0%",
        },
        legend: {
          top: "5%",
          left: "right",
          orient: "vertical",
          itemWidth: 16,
          itemWidth: 16,
          itemStyle: {},
          formatter: (name) => {
            //  自定义图例
            let arr = [];
            let percent;
            for (const item of data) {
              if (item.name === name) {
                percent = item.value + "%";
              }
            }
            arr = ["{a|" + name + "}", "{b|" + percent + "}"];
            return `${name} | ${percent}`;
          },
        },
        color: [
          "#036eb8",
          "#36CBCB",
          "#4DCB73",
          "#FAD53F",
          "#F2637B",
          "#975FE4",
        ],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "60%"],
            avoidLabelOverlap: false,
            center: ["30%", "50%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    handleSubmit() {
      this.$refs.apply.submitUpload();
    },
    handleSubmitYbsbg() {
      this.$refs.ybsbgApply.saveForm();
    },
    getSon(temp) {
      this.applyDialog = false;
      this.ybsbgApplyDialog = false;
      this.$store.dispatch("zxlc/fetchYbsIndexDataAction", {
        year: new Date().getFullYear() + "",
      });
    },
    handleToFhList(lcjd) {
      if (lcjd || lcjd === 0) {
        this.$router.push({
          path: "/zxlc/ybsbg/ybsbgfhList",
          query: { lcjd },
        });
      } else {
        this.$router.push({
          path: "/zxlc/ybsbg/ybsbgfhList",
        });
      }

      localStorage.setItem("zxlcIndexTab", 1);
    },
    handleToMxList() {
      this.$router.push("/zxlc/ybsbg/ybsbgmxList");
      localStorage.setItem("zxlcIndexTab", 1);
    },
    handleToTjList() {
      this.$router.push("/zxlc/ybsbg/ybsbgtjList");
      localStorage.setItem("zxlcIndexTab", 1);
    },
    handleToHldList() {
      this.$router.push("/zxlc/ybsbg/hldbgmxList");
      localStorage.setItem("zxlcIndexTab", 1);
    },
  },
};
</script>
<style lang='less' scoped>
.xmxy_container {
  padding: 15px;
  background-color: #f3f3f4;
  height: 100%;
  .card_1 {
    display: flex;
    justify-content: space-between;
    line-height: 44px;
    .card_1_item {
      background-color: #fff;
      padding: 15px 10px;
      text-align: center;
      font-size: 20px;
      color: #000;
      font-weight: 600;
      cursor: pointer;
      width: 23%;
      box-sizing: border-box;
    }
  }
  .xmxy_middle {
    display: flex;
    margin-top: 15px;
    .card_2 {
      width: calc(40% - 8px);
      margin-right: 8px;
      min-height: 300px;
      margin-left: 16px;
      background-color: #fff;
    }
    .card_3 {
      margin-left: 8px;
      width: calc(40% - 8px);
      background-color: #fff;
      .card_3_content {
        height: calc(100% - 65px);
        #card_3_chart_ybs {
          height: 100%;
        }
      }
    }
    .card_4 {
      width: calc(20% - 16px);
      background-color: #fff;
      .card_4_content {
        display: flex;
        flex-wrap: wrap;
        height: calc(100% - 65px);
        align-items: center;
        color: rgba(0, 0, 0, 0.65);
        > div {
          width: 100%;
          cursor: pointer;
          padding-left: 15px;
          color: #036eb8;
        }
      }
    }
  }
  .xmxy_bottom {
    margin-top: 15px;
    min-height: 380px;
    background-color: #fff;
    .card_5 {
      height: 100%;
    }
    .card_5_content {
      display: flex;
      .card_5_content_left {
        width: 75%;
        #card_5_chart_ybs {
          height: calc(100% - 46px);
          min-height: 300px;
        }
      }
      .card_5_content_right {
        width: 25%;
        padding: 0 15px;
        box-sizing: border-box;
        > div:nth-of-type(2) {
          div {
            height: 44px;
            display: flex;
            justify-content: space-between;
            padding-left: 35px;
            > span:nth-of-type(1) {
              display: flex;
              > .rank_index {
                width: 18px;
                height: 18px;
                border-radius: 50%;
                background-color: #f0f2f5;
                text-align: center;
                line-height: 18px;
                color: rgba(0, 0, 0, 0.65);
                font-size: 12px;
                margin-right: 15px;
              }
            }
          }
          div:nth-child(-n + 3) {
            height: 44px;
            display: flex;
            justify-content: space-between;
            padding-left: 35px;
            > span:nth-of-type(1) {
              display: flex;
              > .rank_index {
                width: 18px;
                height: 18px;
                border-radius: 50%;
                background-color: #314659;
                text-align: center;
                line-height: 18px;
                color: #fff;
                font-size: 12px;
                margin-right: 15px;
              }
            }
          }
        }
      }
      .card_5_suntitle {
        font-size: 16px;
        color: #000;
        font-weight: 600;
        padding: 15px;
      }
    }
  }
  .card_title {
    height: 44px;
    line-height: 44px;
    background-color: #fff;
    padding: 10px;
    font-size: 18px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f3f3f4;
  }
}
</style>